import { ATDLEnumModel } from "./atdl-enum.model";
import { ATDLNParameterType } from "../enums/atdl-parameter-type.enum";
import { ATDLNControlType } from "../enums/atdl-control-type.enum";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class ATDLParameterDataModel {
  // PARAMETERS [location: .Strategies.Strategy.Paramter -> array -> $]
  public refName: string = null; // mapping: 'name' | example: "c_LimitPrice"
  public paramType: ATDLNParameterType = null; // mapping: 'xsi:type' | example: "Price_t"
  public constValue: string = null;
  public dataset: Array<ATDLEnumModel> = null; // UI: enum-dataset for drop-downs {enumId: 'bid': wireValue: 'b'}  [mapping: .Strategies.Strategy.Paramter -> array -> EnumPair -> array -> $]
  public falseWireValue: string = null;
  public trueWireValue: string = null;
  public checkedEnumRef: string = null; // only for checkbox
  public uncheckedEnumRef: string = null; // only for checkbox
  //public multiplyBy100: boolean = null; // DEPRECATED
  public precision: number = null;
  // BFX extension of ATDL
  public disableOnPartFill: boolean = false;
  ///////////////////////////////
  // VALIDITY
  public use: string = null; // mapping: 'use' | example: "required"
  public minValue: number | string = null;
  public maxValue: number | string = null;
  public minLength: number = null;
  public maxLength: number = null;
  ///////////////////////////////
  // META
  public algoId: string = null;
  ///////////////////////////////
  // UI - Parameters
  public value: any = null; // UI
  public icdId: string = null;
  public associatedIcdId: string = null;
  public icdType: ATDLNControlType = null;
  public fixType: number = null;
  public required: boolean = null; // boolean based on use
  public hasAuxiliaryCheckbox: boolean = null;
  public disableValueUpdate: boolean = false;
  ///////////////////////////////
  // Strategy Parameter
  // public strategyParameter: CubiqTS.StrategyParameterImpl = null;

  constructor(name?: string) {
    this.refName = name;
  }
}
